import { Box, styled } from "@mui/material";

export const StyledCreateInvoiceItemTable = styled(Box)(({ theme }) => ({
  width: "100%",
  borderRadius: "5px",
  display: "flex",
  border: `2px solid ${theme.contrast.lighter}`,
  flexDirection: "column",
  button: {
    width: "100%",
    background: theme.contrast.lighter,
    color: theme.color.dark,
    borderRadius: "0 0 5px 5px",
    "&:hover": {
      background: theme.color.dark,
      color: theme.color.background,
    },
  },
  ".tableItem": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    h4: {
      textAlign: "center",
    },
    ".euro": {
      width: "min-content",
    },
    ".price": {
      width: "min-content",
    },
  },
  ".position": {
    gridArea: "1 / 1 / 2 / 2",
  },
  ".description": {
    gridArea: "1 / 2 / 2 / 10",
    justifyContent: "flex-start",
    paddingInline: ".5rem",
    h4: {
      textAlign: "start",
    },
  },
  ".unitPrice": {
    gridArea: "1 / 10 / 2 / 13",
    paddingInline: ".5rem",
  },
  ".amount": {
    gridArea: "1 / 13 / 2 / 15",
  },
  ".unit": {
    gridArea: "1 / 15 / 2 / 17",
  },
  ".totalBefore": {
    gridArea: "1 / 17 / 2 / 20",
    paddingInline: ".5rem",
  },
  ".vat": {
    gridArea: "1 / 20 / 2 / 22",
  },
  ".total": {
    gridArea: "1 / 22 / 2 / 25",
    paddingInline: ".5rem",
  },
  h4: {
    color: theme.color.dark,
    height: "100%",
    width: "100%",
    boxSizing: "border-box",
  },
  ".header": {
    display: "grid",
    gridTemplateColumns: "repeat(24, 1fr)",
    background: theme.color.main,
    height: "4rem",
    alignItems: "center",
    borderRadius: "5px 5px 0 0",
    h4: {
      color: theme.color.background,
      textAlign: "center",
    },
  },
  ".content": {
    ".row": {
      display: "grid",
      gridTemplateColumns: "repeat(24, 1fr)",
      paddingBlock: "1rem",
      position: "relative",
      alignItems: "center",
      "& .MuiInputBase-root": {
        border: `2px solid ${theme.color.dark}`,
        color: theme.color?.dark || theme.palette.text.primary,
        padding: "0",
        width: "95%",
        marginInline: "auto",
      },
      "& .MuiInputBase-input": {
        paddingBlock: ".15rem !important",
        paddingInline: ".15rem",
        width: "100%",
      },
      "& .MuiInput-underline:before, & .MuiInput-underline:after": {
        display: "none",
      },
      ".unitPrice, .total, .totalBefore": {
        justifyContent: "space-between",
      },
    },
    ".remove": {
      borderRadius: "10px",
      position: "absolute",
      right: "-3rem",
      top: "50%",
      transform: "translateY(-50%)",
      width: "min-content",
      svg: {
        color: theme.color.dark,
      },
      "&:hover": {
        svg: { color: theme.color.background },
      },
    },
    ".edit": {
      borderRadius: "10px",
      position: "absolute",
      left: "-3rem",
      top: "50%",
      transform: "translateY(-50%)",
      width: "min-content",
      svg: {
        color: theme.color.dark,
      },
      "&:hover": {
        svg: { color: theme.color.background },
      },
    },
    ".addBtn": {
      justifyContent: "center",
      gap: "1rem",
      h4: {
        fontWeight: "bold",
      },
    },
    "& > *:nth-child(odd)": {
      background: theme.contrast.lighter,
    },
  },
}));
